export enum CustomerAcquisitionsActionTypes {
  API_RESPONSE_SUCCESS = '@@customerAcquisitions/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@customerAcquisitions/API_RESPONSE_ERROR',

  LIST_CUSTOMERACQUISITIONS = '@@customerAcquisitions/LIST_CUSTOMERACQUISITION',
  GET_CUSTOMERACQUISITION = '@@customerAcquisitions/GET_CUSTOMERACQUISITION',
  GET_AUTH_CORP = '@@customerAcquisitions/GET_AUTH_CORP',

  RESET = '@@customerAcquisitions/RESET',
}